/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Match_Col_BrokerInputs */

const cs_import_match_col_broker = /** @type {(inputs: Import_Match_Col_BrokerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makléř`)
};

const en_import_match_col_broker = /** @type {(inputs: Import_Match_Col_BrokerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broker`)
};

/**
* | output |
* | --- |
* | "Broker" |
*
* @param {Import_Match_Col_BrokerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_match_col_broker = /** @type {((inputs?: Import_Match_Col_BrokerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Match_Col_BrokerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_match_col_broker(inputs)
	return cs_import_match_col_broker(inputs)
});